import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { ProjectTeamsTable } from "./project-teams-table";
import { withBranding } from "@/utils/helper";

export const TabProjectTeam = () => {
  const { t } = useTranslation(["projects", "common"]);
  usePageTitle(withBranding(t("projects:project_team")));
  return <ProjectTeamsTable />;
};
